// src/components/HomeScreen.js
import React, { useState } from 'react';
import { Box, Typography, Button, Fade } from '@mui/material';
import { useTheme } from '../contexts/ThemeContext';

const HomeScreen = ({ onOpen }) => {
  // State to trigger a fade-out transition.
  const [transition, setTransition] = useState(false);
  // Get dark mode state
  const { darkMode } = useTheme();

  const handleOpen = () => {
    setTransition(true);
    // Wait for the fade transition to finish (500ms) before calling onOpen.
    setTimeout(() => {
      if (onOpen) {
        onOpen();
      }
    }, 500);
  };

  return (
    <Fade in={!transition} timeout={500}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          // Adjust gradient based on dark mode
          background: darkMode 
            ? 'linear-gradient(135deg, #1a237e, #ffd600)'  // Darker gradient for dark mode
            : 'linear-gradient(135deg, #3f51b5, #ffeb3b)', // Original gradient for light mode
          textAlign: 'center',
          px: 2,
        }}
      >
        {/* Company Name */}
        <Typography
          variant="h2"
          component="h1"
          sx={{
            color: '#ffffff',
            fontWeight: 'bold',
            mb: 2,
            textShadow: '2px 2px 4px rgba(0,0,0,0.4)',
          }}
        >
          Trinity Harper
        </Typography>

        {/* App Purpose */}
        <Typography
          variant="h5"
          component="h2"
          sx={{
            color: '#ffffff',
            mb: 4,
            textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
          }}
        >
          Master Vehicle File
        </Typography>

        {/* Call-to-Action Button */}
        <Button
          variant="contained"
          size="large"
          onClick={handleOpen}
          sx={{
            backgroundColor: darkMode ? '#ffd600' : '#ffeb3b',
            color: darkMode ? '#1a237e' : '#3f51b5',
            fontWeight: 'bold',
            px: 4,
            py: 1.5,
            '&:hover': {
              backgroundColor: darkMode ? '#ffea00' : '#ffe000',
            },
          }}
        >
          Open
        </Button>
      </Box>
    </Fade>
  );
};

export default HomeScreen;